// extracted by mini-css-extract-plugin
module.exports = {"colorLabel":"RightPanel_colorLabel__38suO","tableRowPPStages":"RightPanel_tableRowPPStages__3FmiJ","stage":"RightPanel_stage__sYljy"};